/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {WidgetBlock} from 'pages/Home/DigitalCast/models/widgets';

const getWidgetsBlockByChartId = (widgetBlocks: WidgetBlock[], chartId: ChartIds): WidgetBlock => {
  if (!widgetBlocks.length) {
    throw new Error('Widget blocks not found');
  }

  const index = widgetBlocks.findIndex(
    block => block.commonWidgets?.includes(chartId) || block.subMenu?.widgets.includes(chartId),
  );

  if (index > -1) {
    return widgetBlocks[index];
  }

  // Фолбэк: динамические виджеты CR относим к блоку "Воронка"
  if (chartId.startsWith('funnel_cr_')) {
    const funnelIndex = widgetBlocks.findIndex(block => block.id === 'funnel');
    if (funnelIndex > -1) return widgetBlocks[funnelIndex];
  }

  return widgetBlocks[0];
};

export default getWidgetsBlockByChartId;
